import { ApiHttpClient } from './../../http/clients/api';
import { Observable } from 'rxjs';

/**
 * CRUD services used with the ngxs store should extend this. Together with the
 * EntityState store, it gives you instant basic store operations.
 *
 * T is the entity type this services handles.
 */
export abstract class AbstractCrudService<T extends { id?: number }> {

  // Override in service classes that extend this class.
  baseUrl: string;

  constructor(private http: ApiHttpClient) {}

  // Get a single entity by id or other unique identifier.
  get(id: number|string): Observable<T> {
    return this.http.get<T>(this.baseUrl + '/' + id);
  }

  // Get multiple entities.
  getIndex(): Observable<T[]> {
    return this.http.get<T[]>(this.baseUrl);
  }

  // Create an entity.
  create(entity: T): Observable<T> {
    return this.http.post<T>(this.baseUrl, entity);
  }

  // Update an entity.
  update(entity: T): Observable<T> {
    return this.http.put<T>(this.baseUrl + '/' + entity.id, entity);
  }

  // Delete an entity. Returns true if successful.
  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.baseUrl + '/' + id);
  }
}
